/**
 * When activeStyleClass elements are clicked on we will toggle activeStylClass on the containerSelector element.
 *
 * @param containerSelector
 * @param triggerSelector
 * @param activeStyleClass
 */
export default class HeaderSearchForm {
	constructor(containerSelector:string, triggerSelector:string, focusOnSelector:string, activeStyleClass:string) {
		const activeHandler = (container:Element, trigger:Element): void => {
			let focusOn = container.querySelector(focusOnSelector) as HTMLElement;
			if (focusOn) {
				focusOn.focus();
			}
		};

		const containerList = document.querySelectorAll(containerSelector);
		for (let i=0; i < containerList.length; i++) {
			const container = containerList[i];

			const triggerList = container.querySelectorAll(triggerSelector);
			for (let j=0; j < triggerList.length; j++) {
				const trigger = triggerList[j];
				trigger.addEventListener('click', (e) => {
					e.preventDefault();
					if (container.classList.toggle('open') && activeHandler !== undefined) {
						activeHandler(container, trigger);
					}
				});
			}
		}
	}
}